import React from 'react';
import ImageWithAction from './Image';

const Clipart = ({ object, onClick }) => {
  return <ImageWithAction object={object} onClick={onClick} />;
};

export default Clipart;
